export const SIDENAV_WIDTH = 64;
export const TOPBAR_HEIGHT = 48;
export const INLINE_BOOKMARK_DELIMITER_LEFT = '[';
export const INLINE_BOOKMARK_DELIMITER_RIGHT = ']';
